module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-pro-onboarding/upgrade/upgrade-messages@2x.png"